import {Link} from 'react-router';

import packageData from '../../package.json';

function About() {
  const {version} = packageData;
  return (
    <div>
      <div><Link to="/">Back</Link></div>

      <p>
        This is the about page, now as jsx! Version {version}.
      </p>
    </div>
  );
}

export default About;
